export function getFieldTypeForDisplay(fieldType) {
  let fieldTypeForDisplay;
  if(fieldType === 'Ordinal') {
    fieldTypeForDisplay = 'Range';
  } else if(fieldType === 'Categorical') {
    fieldTypeForDisplay = 'Category';
  } else {
    fieldTypeForDisplay = fieldType;
  }

  return fieldTypeForDisplay;
}

export function getFieldTypeFromDisplayType(fieldTypeForDisplay) {
  let fieldType;
  if(fieldTypeForDisplay === 'Range') {
    fieldType = 'Ordinal';
  } else if(fieldTypeForDisplay === 'Category') {
    fieldType = 'Categorical';
  } else {
    fieldType = fieldTypeForDisplay;
  }

  return fieldType;
}

export function truncateString(string, maxLength) {
  if (string.length <= maxLength) {
    return string;
  }
  const delimit = string.lastIndexOf(' ', (maxLength - 3));
  if (delimit !== -1) {
    return string.substr(0, delimit) + ' ...';
  }
  return string.substr(0, (maxLength - 3)) + '...';
}
